export const HOME_PAGE_PATH = "/";
export const BLOG_PAGE_PATH = "/blog";
export const ABOUT_PAGE_PATH = "/about";
export const WORK_PAGE_PATH = "/work";
export const ADMIN_LOGIN_PAGE_PATH = "/admin";
export const BLOG_POST_EDITOR = "/admin/editor";
export const ADD_UPDATE_DATA = "/admin/update";
